import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { colors } from "./ui/tokens";

// SVG Icons modernes
const DashboardIcon = ({ active }: { active: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? "white" : "#666"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
    <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
  </svg>
);
const UsersIcon = ({ active }: { active: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? "white" : "#666"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const PublicationsIcon = ({ active }: { active: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? "white" : "#666"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
    <line x1="10" y1="9" x2="8" y2="9"/>
  </svg>
);
const ReportsIcon = ({ active }: { active: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? "white" : "#666"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);
const VenuesIcon = ({ active }: { active: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? "white" : "#666"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);
const PaymentsIcon = ({ active }: { active: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? "white" : "#666"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2"/>
    <line x1="1" y1="10" x2="23" y2="10"/>
  </svg>
);
const EmailsIcon = ({ active }: { active: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? "white" : "#666"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const MessagesIcon = ({ active }: { active: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? "white" : "#666"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);
const StaffIcon = ({ active }: { active: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? "white" : "#666"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.5 21a8.5 8.5 0 0 0-17 0"/><circle cx="12" cy="8" r="5"/>
  </svg>
);
const FlashIcon = ({ active }: { active: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? "white" : "#666"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
  </svg>
);
const VibesIcon = ({ active }: { active: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active ? "white" : "#666"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="4"/>
  </svg>
);
const LogoutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C0392B" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);
const CollapseIcon = ({ collapsed }: { collapsed: boolean }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2" strokeLinecap="round">
    {collapsed ? <polyline points="9 18 15 12 9 6"/> : <polyline points="15 18 9 12 15 6"/>}
  </svg>
);

// Deux paliers de staff — 'moderator' < 'admin', mêmes noms que côté backend (voir
// requireStaffRole, middleware/auth.ts). Chaque entrée de nav porte le niveau minimal requis
// pour la voir ; le master (niveau 99) voit tout, y compris Messages/Équipe qui n'appartiennent
// qu'à lui. Un modérateur voit ce qu'il doit modérer (contenu + signalements) ; un admin voit
// tout le reste (hors messages/équipe).
const STAFF_LEVELS: Record<string, number> = { moderator: 1, admin: 2 };
const navLevel = (user?: LayoutUser) => (user?.is_master_admin ? 99 : user?.staff_role ? STAFF_LEVELS[user.staff_role] || 0 : 0);

const NAV_ITEMS = [
  { path: "/", label: "Dashboard", Icon: DashboardIcon, min: 2 },
  { path: "/users", label: "Utilisateurs", Icon: UsersIcon, min: 1 },
  { path: "/publications", label: "Publications", Icon: PublicationsIcon, min: 1 },
  { path: "/venues", label: "Lieux", Icon: VenuesIcon, min: 1 },
  { path: "/flash", label: "Flash", Icon: FlashIcon, min: 1 },
  { path: "/vibes", label: "Vibes & Lives", Icon: VibesIcon, min: 1 },
  { path: "/reports", label: "Signalements", Icon: ReportsIcon, min: 1 },
  { path: "/payments", label: "Paiements", Icon: PaymentsIcon, min: 2 },
  { path: "/emails", label: "Emails", Icon: EmailsIcon, min: 2 },
  // Messages (contenu déchiffré) et Équipe (attribution des rôles) n'appartiennent qu'au master —
  // masquer l'entrée pour tout le monde d'autre évite de mener vers un 403 sans explication.
  { path: "/messages", label: "Messages", Icon: MessagesIcon, min: 99 },
  { path: "/staff", label: "Équipe", Icon: StaffIcon, min: 99 },
];

type LayoutUser = { name: string; email: string; is_master_admin?: boolean; staff_role?: string | null } | null;

export default function Layout({ children, onLogout, user }: { children: React.ReactNode; onLogout: () => void; user?: LayoutUser }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const level = navLevel(user);
  const NAV = NAV_ITEMS.filter(item => level >= item.min);

  return (
    <div style={{ display: "flex", minHeight: "100vh", backgroundColor: colors.bg }}>
      {/* SIDEBAR */}
      <div style={{
        width: collapsed ? 72 : 240,
        backgroundColor: "#0a0a0a",
        display: "flex",
        flexDirection: "column",
        transition: "width 0.25s ease",
        position: "fixed",
        top: 0, left: 0, bottom: 0,
        zIndex: 100,
        boxShadow: "4px 0 20px rgba(0,0,0,0.3)",
      }}>
        {/* Logo */}
        <div style={{
          padding: collapsed ? "20px 16px" : "20px 20px",
          borderBottom: "1px solid #1a1a1a",
          display: "flex",
          alignItems: "center",
          justifyContent: collapsed ? "center" : "space-between",
          minHeight: 72,
        }}>
          {!collapsed && (
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              {/* Logo OLTODO */}
              <div style={{ width: 36, height: 36, borderRadius: 10, backgroundColor: "white", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, overflow: "hidden" }}>
                <img src="/oltodo.png" alt="OLTODO" style={{ width: "80%", height: "80%", objectFit: "contain" }} />
              </div>
              <div>
                <div style={{ color: "white", fontWeight: 900, fontSize: 16, letterSpacing: 1.5 }}>OLTODO</div>
                <div style={{ color: "#444", fontSize: 10, letterSpacing: 0.5 }}>Admin Panel</div>
              </div>
            </div>
          )}
          {collapsed && (
            <div style={{ width: 36, height: 36, borderRadius: 10, backgroundColor: "white", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
              <img src="/oltodo.png" alt="OLTODO" style={{ width: "80%", height: "80%", objectFit: "contain" }} />
            </div>
          )}
          {!collapsed && (
            <button onClick={() => setCollapsed(true)} style={{ background: "none", border: "none", cursor: "pointer", padding: 4, borderRadius: 6, display: "flex" }}>
              <CollapseIcon collapsed={false} />
            </button>
          )}
        </div>

        {/* Bouton expand si collapsed */}
        {collapsed && (
          <button onClick={() => setCollapsed(false)} style={{ background: "none", border: "none", cursor: "pointer", padding: "8px", display: "flex", justifyContent: "center", borderBottom: "1px solid #1a1a1a" }}>
            <CollapseIcon collapsed={true} />
          </button>
        )}

        {/* Navigation */}
        <nav style={{ flex: 1, padding: "12px 8px", overflowY: "auto" }}>
          {NAV.map(({ path, label, Icon }) => {
            const active = location.pathname === path;
            return (
              <div
                key={path}
                onClick={() => navigate(path)}
                title={collapsed ? label : undefined}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  padding: collapsed ? "12px" : "11px 14px",
                  cursor: "pointer",
                  backgroundColor: active ? "#0000FF" : "transparent",
                  borderRadius: 10,
                  margin: "2px 0",
                  transition: "all 0.15s",
                  justifyContent: collapsed ? "center" : "flex-start",
                  position: "relative",
                }}
                onMouseEnter={e => !active && (e.currentTarget.style.backgroundColor = "#1a1a1a")}
                onMouseLeave={e => !active && (e.currentTarget.style.backgroundColor = "transparent")}
              >
                <Icon active={active} />
                {!collapsed && (
                  <span style={{ color: active ? "white" : "#888", fontSize: 14, fontWeight: active ? 600 : 400, whiteSpace: "nowrap" }}>
                    {label}
                  </span>
                )}
                {/* Indicateur actif */}
                {active && collapsed && (
                  <div style={{ position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)", width: 3, height: 20, backgroundColor: "white", borderRadius: 2 }} />
                )}
              </div>
            );
          })}
        </nav>

        {/* User + Logout */}
        <div style={{ padding: "12px 8px", borderTop: "1px solid #1a1a1a" }}>
          {!collapsed && (
            <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", marginBottom: 4, backgroundColor: "#111", borderRadius: 10 }}>
              <div style={{ width: 32, height: 32, borderRadius: "50%", backgroundColor: "#0000FF", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontWeight: 700, fontSize: 12, flexShrink: 0 }}>
                {(user?.name || "?").split(" ").map(p => p[0]).join("").slice(0, 2).toUpperCase()}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ color: "white", fontSize: 13, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user?.name || "Administrateur"}</div>
                <div style={{ color: "#444", fontSize: 11, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user?.email || "Super Admin"}</div>
              </div>
            </div>
          )}
          <div
            onClick={onLogout}
            title={collapsed ? "Déconnexion" : undefined}
            style={{
              display: "flex", alignItems: "center", gap: 12,
              padding: collapsed ? "12px" : "10px 14px",
              cursor: "pointer", borderRadius: 10,
              justifyContent: collapsed ? "center" : "flex-start",
              transition: "background 0.15s",
            }}
            onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#1a1a1a")}
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = "transparent")}
          >
            <LogoutIcon />
            {!collapsed && <span style={{ color: "#C0392B", fontSize: 14, fontWeight: 500 }}>Déconnexion</span>}
          </div>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div style={{
        marginLeft: collapsed ? 72 : 240,
        flex: 1,
        transition: "margin-left 0.25s ease",
        minHeight: "100vh",
        backgroundColor: colors.bg,
      }}>
        {children}
      </div>
    </div>
  );
}
